module.exports = __webpack_public_path__ + "img/Owner_In_A_Suit.fa536f8.png";